module.exports = __webpack_public_path__ + "static/jova-215931ea52b098cb5112a6aff5fee55d.png";